import { Action } from 'redux';
import {
  IActionCreatorErrorOptions,
  IErrorAction,
} from '../../../../../cross-cutting-concerns/state-management/interfaces/StateManagement.types';
import { SiteClientListSitesWithOperatingTimeOptions } from 'app/modules/site-management/SiteClient';
import { SiteListWithOperatingTime } from 'app/modules/site-management/interfaces/Site.types';
import { SiteOperatingTimePeriod } from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';
import { Optional } from 'lib/types/Optional';

export type IGetSiteListWithOperatingTimeRequestOptions = SiteClientListSitesWithOperatingTimeOptions & {
  /** Ids of the currently selected "no site assigned" machines, aggregated into a synthetic bar. */
  noSiteMachineIds?: string[];
};

export type ISetPeriodFilter = Action<typeof SiteWidgetsFleetDashboardActions.SET_PERIOD_FILTER> & {
  payload: {
    period: {
      startDate: string;
      endDate: string;
    };
  };
};

export type IGetSiteListWithOperatingTimeRequestAction = Action<
  typeof SiteWidgetsFleetDashboardActions.GET_SITE_LIST_WITH_OPERATING_TIME_REQUEST
> & {
  payload: IGetSiteListWithOperatingTimeRequestOptions;
};

export type IGetSiteListWithOperatingTimeSuccessOptions = SiteListWithOperatingTime & {
  noSiteMachinesOperatingTime?: Optional<SiteOperatingTimePeriod>;
};
export type IGetSiteListWithOperatingTimeSuccessAction = Action<
  typeof SiteWidgetsFleetDashboardActions.GET_SITE_LIST_WITH_OPERATING_TIME_SUCCESS
> & {
  payload: IGetSiteListWithOperatingTimeSuccessOptions;
};

export type IGetSiteListWithOperatingTimeErrorAction = IErrorAction<
  typeof SiteWidgetsFleetDashboardActions.GET_SITE_LIST_WITH_OPERATING_TIME_ERROR
>;

export class SiteWidgetsFleetDashboardActions {
  public static SET_PERIOD_FILTER = 'SITE_WIDGETS_FLEET_DASHBOARD::SET_PERIOD_FILTER';

  public static GET_SITE_LIST_WITH_OPERATING_TIME_REQUEST =
    'SITE_WIDGETS_FLEET_DASHBOARD::GET_SITE_LIST_WITH_OPERATING_TIME_REQUEST';

  public static GET_SITE_LIST_WITH_OPERATING_TIME_SUCCESS =
    'SITE_WIDGETS_FLEET_DASHBOARD::GET_SITE_LIST_WITH_OPERATING_TIME_SUCCESS';

  public static GET_SITE_LIST_WITH_OPERATING_TIME_ERROR =
    'SITE_WIDGETS_FLEET_DASHBOARD::GET_SITE_LIST_WITH_OPERATING_TIME_ERROR';

  public static RESET_STATE = 'SITE_WIDGETS_FLEET_DASHBOARD::RESET_STATE';

  public static setPeriodFilter(period: { startDate: string; endDate: string }): ISetPeriodFilter {
    return {
      type: SiteWidgetsFleetDashboardActions.SET_PERIOD_FILTER,
      payload: {
        period,
      },
    };
  }

  public static getSiteListWithOperatingTimeRequest({
    paginationOptions,
    sortOptions,
    period,
    filter,
    noSiteMachineIds,
  }: IGetSiteListWithOperatingTimeRequestOptions): IGetSiteListWithOperatingTimeRequestAction {
    return {
      type: SiteWidgetsFleetDashboardActions.GET_SITE_LIST_WITH_OPERATING_TIME_REQUEST,
      payload: {
        paginationOptions,
        sortOptions,
        period,
        filter,
        noSiteMachineIds,
      },
    };
  }

  public static getSiteListWithOperatingTimeSuccess(
    data: IGetSiteListWithOperatingTimeSuccessOptions
  ): IGetSiteListWithOperatingTimeSuccessAction {
    return {
      type: SiteWidgetsFleetDashboardActions.GET_SITE_LIST_WITH_OPERATING_TIME_SUCCESS,
      payload: data,
    };
  }

  public static getSiteListWithOperatingTimeError({
    error,
  }: IActionCreatorErrorOptions): IGetSiteListWithOperatingTimeErrorAction {
    return {
      type: SiteWidgetsFleetDashboardActions.GET_SITE_LIST_WITH_OPERATING_TIME_ERROR,
      error,
    };
  }

  public static resetState(): Action<typeof SiteWidgetsFleetDashboardActions.RESET_STATE> {
    return {
      type: SiteWidgetsFleetDashboardActions.RESET_STATE,
    };
  }
}
